module.exports = __webpack_public_path__ + "static/media/14.c79fe37d.png";


//////////////////
// WEBPACK FOOTER
// ./src/sass/images/landpage/14.png
// module id = 300
// module chunks = 0